import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardText,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    LinkList,
    LinkListItem,
    Icon
} from 'design-react-kit';
import { properties } from '../config/properties';
import {useNavigate} from "react-router-dom";

// Helper per recuperare la lista delle Camere di Commercio
async function getCciaaList() {
    try {
        const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/cciaa`);
        if (!res.ok) {
            throw new Error(`Errore HTTP: ${res.status}`);
        }
        return await res.json();
    } catch (e) {
        console.error("Errore nel caricamento delle CCIAA:", e);
        return [];
    }
}

const Home = ({user} ) => {
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const [cciaas, setCciaas] = useState([]);

    const toggle = () => setIsOpen(!isOpen);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getCciaaList();
            setCciaas(data);
        };
        fetchData();
    }, []);


    function handleClickNavigate() {
        const isLogged =
            user !== null &&
            user !== undefined &&
            Object.keys(user).length > 0;

        if (isLogged) {
            navigate("/private/dashboard");
        } else {
            window.location.href = `${properties.fullBaseUrl}${properties.baseAppUrl}/user/service/callbackLogin`;
        }
    }



    return (
        <>
            {/* Sezione "Hero" introduttiva */}
            <div className="bg-primary text-white py-5">
                <Container className="text-center">
                    <h1 className="display-4 font-weight-bold">Specimen Firme</h1>
                    <p className="lead">
                        Il servizio online per la verifica semplice e veloce dei poteri di firma del Sistema Camerale.
                    </p>
                </Container>
            </div>

            {/* Sezione principale con le card informative */}
            <Container className="py-5 small">
                <Row className="justify-content-center">

                    {/* Card "Cos'è" */}
                    <Col md={6} className="mb-4">
                        <Card className="h-100 shadow-sm border-0 card-hover">
                            <CardBody className="d-flex flex-column ">
                                <div className="d-flex align-items-center mb-3">
                                    <Icon icon="it-info-circle" color="primary" size="lg" className="mr-3" />
                                    <CardTitle tag="h2" className="mb-0 text-primary">Cos'è Specimen Firme</CardTitle>
                                </div>
                                <div className="lead">
                                    È il nuovo servizio online, realizzato da Infocamere con la collaborazione delle Camere di Commercio Italiane, per l'individuazione dei soggetti con poteri di firma. Consente di verificare la validità delle firme apposte su atti e documenti camerali, comprese quelle dei soggetti delegati, valide anche all'estero.
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* Card "Come Accedere" */}
                    <Col md={6} className="mb-4">
                        <Card className="h-100 shadow-sm border-0 bg-light card-hover">
                            <CardBody>
                                <div className="d-flex align-items-center mb-3">
                                    <Icon icon="it-search" color="primary" size="lg" className="mr-3" />
                                    <CardTitle tag="h2" className="mb-0 text-primary">Cosa si può fare</CardTitle>
                                </div>
                                <div className="lead">
                                    Effettua ricerche sui soggetti abilitati a firmare per conto della Camera di Commercio, visualizzando in dettaglio la firma e le deleghe attribuite. Puoi anche consultare la lista completa degli specimen per ogni singolo ente.
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                        <Row>

                            {/* Card "Contatti Camere di Commercio" */}
                            <Col md={6} className="mb-4">
                                <Card className="h-100 shadow-sm border-0 ">
                                    <CardBody>
                                        <div className="d-flex align-items-center mb-3">
                                            <Icon icon="it-link" color="primary" size="lg" className="mr-3" />
                                            <CardTitle tag="h2" className="mb-0 text-primary">Contatta la tua CCIAA</CardTitle>
                                        </div>
                                        <div className="lead">
                                            Seleziona la tua Camera di Commercio dall'elenco per visitare il sito ufficiale e ottenere maggiori informazioni.
                                        </div>
                                        <br/>
                                        <div>
                                        <Dropdown  isOpen={isOpen} toggle={toggle}>
                                            <DropdownToggle caret  className="w-100 btn btn-outline-primary">
                                                Seleziona un ente
                                            </DropdownToggle>
                                            <DropdownMenu className="w-100 dropdown-menu-scrollable">
                                                <LinkList>
                                                    {cciaas.length > 0 ? (
                                                        cciaas.map((item) => (
                                                            <LinkListItem
                                                                key={item.id} // Usa un ID univoco se disponibile
                                                                inDropdown
                                                                href={item.sitoInternet}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-dark"
                                                            >
                                                                {item.nomeProvincia}
                                                            </LinkListItem>
                                                        ))
                                                    ) : (
                                                        <LinkListItem inDropdown disabled>
                                                            Nessun ente disponibile
                                                        </LinkListItem>
                                                    )}
                                                </LinkList>
                                            </DropdownMenu>
                                        </Dropdown>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            {/* Card "Cosa si può fare" */}
                            <Col md={6} className="mb-4">
                                <Card className="h-100 shadow-sm border-0 card-hover">
                                    <CardBody className="d-flex flex-column">
                                        <div className="d-flex align-items-center mb-3">
                                            <Icon icon="it-user" color="primary" size="lg" className="mr-3" />
                                            <CardTitle tag="h2" className="mb-0 text-primary">Come Accedere</CardTitle>
                                        </div>
                                        <div className="lead">
                                            Per la consultazione accedi dentro la tua <span  onClick={ handleClickNavigate} style={{textDecoration:"none",cursor:'pointer', color:"#06c"}}><strong>Area Riservata</strong> </span> con le tue credenziali. Se non le possiedi, puoi richiederle contattando la tua Camera di Commercio.
                                            
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>



                        </Row>


            </Container>
        </>
    );
};

export default Home;